import React from "react";

const DurationSelector = ({
  label,
  duration,
  setDuration,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  durationOptions,
  minDate,
}) => {
  // Helper to add days to a date string
  function addDays(dateStr, days) {
    const date = new Date(dateStr);
    date.setDate(date.getDate() + days - 1);
    return date.toISOString().split("T")[0];
  }

  return (
    <>
      <tr className="row-div">
        <td>
          <div className="field-div">{label} Duration:</div>
        </td>
        <td>
          <div className="dropdown" style={{ marginBottom: 8 }}>
            <button
              className="btn btn-secondary dropdown-toggle dropDown-custom"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {duration !== "" ? duration + " days" : "Select"}
            </button>
            <ul className="dropdown-menu menu2">
              {durationOptions.map((d, idx) => (
                <li
                  onClick={() => {
                    setDuration(d);
                    setStartDate("");
                    setEndDate("");
                  }}
                  key={idx}
                >
                  <a className="dropdown-item">{d} days</a>
                </li>
              ))}
            </ul>
          </div>
        </td>
      </tr>
      <tr className="row-div">
        <td>
          <div className="field-div">Start/End Date:</div>
        </td>
        <td>
          <div className="date-div">
            <input
              type="date"
              value={startDate}
              min={minDate}
              disabled={duration === ""}
              onChange={(e) => {
                setStartDate(e.target.value);
                if (duration) {
                  setEndDate(addDays(e.target.value, duration));
                } else {
                  setEndDate("");
                }
              }}
              className="form-control mt-1 input-field"
              style={{ minWidth: "150px" }}
              placeholder="Start Date"
            />
            <input
              type="date"
              value={endDate}
              disabled
              className="form-control mt-1 input-field"
              style={{ minWidth: "150px" }}
              placeholder="End Date"
            />
          </div>
        </td>
      </tr>
    </>
  );
};

export default DurationSelector;
